// removed by extract-text-webpack-plugin
module.exports = {"base":"TextOverflow_base--1L7dU"};


//////////////////
// WEBPACK FOOTER
// ./components/TextOverflow/TextOverflow.scss
// module id = 2455
// module chunks = 11